import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Appointment, AppointmentRequest, AppointmentUpdate } from '../../models/appointment.model';

export const AppointmentActions = createActionGroup({
  source: 'Appointments',
  events: {
    'Load Appointments': props<{ admin?: boolean }>(),
    'Load Appointments Success': props<{ appointments: Appointment[] }>(),
    'Load Appointments Failure': props<{ error: string }>(),
    'Create Appointment': props<{ request: AppointmentRequest }>(),
    'Create Appointment Success': props<{ appointment: Appointment }>(),
    'Create Appointment Failure': props<{ error: string }>(),
    'Update Appointment': props<{ id: string; update: AppointmentUpdate }>(),
    'Update Appointment Success': props<{ appointment: Appointment }>(),
    'Update Appointment Failure': props<{ error: string }>(),
    'Clear Submission State': emptyProps(),
  },
});
